import { render, staticRenderFns } from "./OptInTerms.vue?vue&type=template&id=648c9660&"
import script from "./OptInTerms.vue?vue&type=script&lang=js&"
export * from "./OptInTerms.vue?vue&type=script&lang=js&"
import style0 from "./OptInTerms.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports